//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchBox from '~/components/SearchBox';
import LoadingData from '~/components/LoadingData';
import Testimonial from '~/components/Testimonial';
import WhoTestimonial from '~/components/WhoTestimonial';
import WhoPayment from '~/components/WhoPayment';

export default {
    layout: function layout(context) {
        return global.getTheme();
    },

    components: {
        SearchBox: SearchBox, LoadingData: LoadingData, Testimonial: Testimonial, WhoTestimonial: WhoTestimonial, WhoPayment: WhoPayment
    },
    data: function data() {
        return {
            loading: false,
            searchText: '',
            type: 'email',
            view: 'default'
        };
    },
    created: function created() {
        this.view = global.getTheme();
    },

    computed: {
        lang: function lang() {
            return this.$root._route.params.lang;
        }
    },
    methods: {
        startLoading: function startLoading(flag, searchText) {
            this.loading = flag;
            this.searchText = searchText;
        },
        stopLoading: function stopLoading(flag) {
            this.loading = flag;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/email-search.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/email-search.vue
// module chunks = 6